<div>
  {{ 'topBar.status' | translate }}
  <span class="ml-2 p-1 badge bg-danger text-white font-size-12 text-uppercase">
    Trialing
  </span>
</div>